/* Kategoripanelet («Alle kategorier»): bytt fane når musa holdes over, og
   kjøretøysøk i første fane. Søket bruker samme RPC som sykkelsøket (ymm_sok)
   og sender kunden videre til /pages/sykkelsok med sykkelen valgt. */
(function () {
  const meny = document.querySelector('mega-menu-main');
  if (!meny) return;

  // Fanene bytter ved hover, med et lite opphold så de ikke flimrer når musa krysser lista.
  meny.querySelectorAll('.mega-menu-main-nav-item').forEach((a) => {
    let t;
    a.addEventListener('mouseenter', () => { t = setTimeout(() => { if (!a.classList.contains('current')) a.click(); }, 110); });
    a.addEventListener('mouseleave', () => clearTimeout(t));
  });

  const rot = meny.querySelector('[data-mm-finn]');
  if (!rot) return;
  const API = rot.dataset.api.replace(/\/$/, '') + '/rest/v1/rpc/';
  const NOKKEL = rot.dataset.nokkel;
  const felt = rot.querySelector('[data-mm-q]');
  const boks = rot.querySelector('[data-mm-forslag]');
  const garasje = rot.querySelector('[data-mm-garasje]');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const lenke = (merke, modell, aar) => {
    const p = new URLSearchParams({ merke, modell });
    if (aar) p.set('aar', aar);
    return '/pages/sykkelsok?' + p.toString();
  };

  // Garasjen fra sykkelsøket (localStorage), som snarveier.
  try {
    const liste = JSON.parse(localStorage.getItem('mcs_garasje') || '[]');
    if (liste.length) {
      garasje.innerHTML = '<span>Garasjen din:</span>' + liste.map((g) =>
        `<a href="${lenke(g.merke, g.modell, g.aar)}">${esc(g.merke)} ${esc(g.modell)} ${esc(g.aar)}</a>`).join('');
    }
  } catch (e) { /* privat modus */ }

  let forslag = [], aktiv = -1, timer;
  function lukk() { boks.hidden = true; boks.innerHTML = ''; aktiv = -1; }
  function tegn() {
    boks.innerHTML = forslag.length
      ? forslag.map((r, i) => `<a class="mm-finn__valg${i === aktiv ? ' er-aktiv' : ''}" href="${lenke(r.merke, r.modell, r.aar)}"><strong>${esc(r.merkenavn)} ${esc(r.modell)}</strong><span>${r.aar ? esc(r.aar) : esc(r.aar_fra) + '–' + esc(r.aar_til)}</span></a>`).join('')
      : '<div class="mm-finn__tom">Fant ingen sykkel. Prøv for eksempel «mt07 2021».</div>';
    boks.hidden = false;
  }
  felt.addEventListener('input', () => {
    clearTimeout(timer);
    const q = felt.value.trim();
    if (q.length < 2) { lukk(); return; }
    timer = setTimeout(async () => {
      try {
        const svar = await fetch(API + 'ymm_sok', {
          method: 'POST',
          headers: { apikey: NOKKEL, Authorization: 'Bearer ' + NOKKEL, 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ p_q: q, p_antall: 8 }),
        }).then((r) => r.json());
        if (felt.value.trim() !== q) return;
        forslag = Array.isArray(svar) ? svar : []; aktiv = forslag.length ? 0 : -1; tegn();
      } catch (e) { lukk(); }
    }, 250);
  });
  felt.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { lukk(); return; }
    if (boks.hidden || !forslag.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); aktiv = (aktiv + 1) % forslag.length; tegn(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); aktiv = (aktiv - 1 + forslag.length) % forslag.length; tegn(); }
    else if (e.key === 'Enter') { e.preventDefault(); const r = forslag[aktiv]; if (r) location.href = lenke(r.merke, r.modell, r.aar); }
  });
})();
